import { TranslationType } from '../../types';

const occupancyTypesStatusCode = (t: TranslationType) => {
  return {
    '01': t('Status-Code-Occupancy-Type-Homeowner'),
    '02': t('Status-Code-Occupancy-Type-Small-Rental')
  };
};

export const occupancyTypes = (value: string, t: TranslationType): string => {
  if (value in occupancyTypesStatusCode(t))
    return occupancyTypesStatusCode(t)[value as keyof typeof occupancyTypesStatusCode];
  return '';
};

const locationTypesStatusCode = (t: TranslationType) => {
  return {
    U: t('Status-Code-Location-Type-Urban'),
    R: t('Status-Code-Location-Type-Rural')
  };
};

export const locationTypes = (value: string, t: TranslationType): string => {
  if (value in locationTypesStatusCode(t))
    return locationTypesStatusCode(t)[value as keyof typeof locationTypesStatusCode];
  return '';
};

const dwellingTypesStatusCode = (t: TranslationType) => {
  return {
    '001': t('Status-Code-Dwelling-Type-Single'),
    '002': t('Status-Code-Dwelling-Type-Semi-Detached'),
    '003': t('Status-Code-Dwelling-Type-Duplex'),
    '004': t('Status-Code-Dwelling-Type-Row'),
    '005': t('Status-Code-Dwelling-Type-Apartment'),
    '006': t('Status-Code-Dwelling-Type-Mobile'),
    '008': t('Status-Code-Dwelling-Type-Triplex'),
    '009': t('Status-Code-Dwelling-Type-Other'),
    '010': t('Status-Code-Dwelling-Type-Stacked'),
    '017': t('Status-Code-Dwelling-Type-Modular-Home'),
    '018': t('Status-Code-Dwelling-Type-Modular-Fourplex')
  };
};

export const dwellingTypes = (value: string, t: TranslationType): string => {
  if (value in dwellingTypesStatusCode(t))
    return dwellingTypesStatusCode(t)[value as keyof typeof dwellingTypesStatusCode];
  return '';
};
const tenureTypesStatusCode = (t: TranslationType) => {
  return {
    '01': t('Status-Code-Tenure-Type-Freehold'),
    '1': t('Status-Code-Tenure-Type-Freehold'),
    '02': t('Status-Code-Tenure-Type-Leasehold'),
    '2': t('Status-Code-Tenure-Type-Leasehold'),
    '03': t('Status-Code-Tenure-Type-Condo'),
    '3': t('Status-Code-Tenure-Type-Condo')
  };
};

export const tenureTypes = (value: string, t: TranslationType): string => {
  if (value in tenureTypesStatusCode(t))
    return tenureTypesStatusCode(t)[value as keyof typeof tenureTypesStatusCode];
  return '';
};
const interestTypesStatusCode = (t: TranslationType) => {
  return {
    '01': t('Status-Code-Interest-Type-Fixed'),
    '02': t('Status-Code-Interest-Type-Adjustable'),
    '03': t('Status-Code-interest-Type-Buydown'),
    '04': t('Status-Code-interest-Type-VRM'),
    '06': t('Status-Code-interest-Type-Capped-VRM')
  };
};

export const interestTypes = (value: string, t: TranslationType): string => {
  if (value in interestTypesStatusCode(t))
    return interestTypesStatusCode(t)[value as keyof typeof interestTypesStatusCode];
  return '';
};
const grandfatheredTypesStatusCode = (t: TranslationType) => {
  return {
    '0': t('Status-Code-Grandfathered-Type-Grandfathered-Pre'),
    '1': t('Status-Code-Grandfathered-Type-Grandfathered-Post'),
    '2': t('Status-Code-Grandfathered-Type-NonGrandfathered')
  };
};

export const grandfatheredTypes = (value: string, t: TranslationType): string => {
  if (value in grandfatheredTypesStatusCode(t))
    return grandfatheredTypesStatusCode(t)[value as keyof typeof grandfatheredTypesStatusCode];
  return '';
};
const loanPurposeTypesStatusCode = (t: TranslationType) => {
  return {
    '1': t('Status-Code-Loan-Purpose-Type-Purchase'),
    E: t('Status-Code-Loan-Purpose-Type-Refinance'),
    T: t('Status-Code-Loan-Purpose-Type-Transfer/Switch'),
    D: t('Status-Code-Loan-Purpose-Type-Portability'),
    '6': t('Status-Code-Loan-Purpose-Type-Portability')
  };
};

export const loanPurposeTypes = (value: string, t: TranslationType): string => {
  if (value in loanPurposeTypesStatusCode(t))
    return loanPurposeTypesStatusCode(t)[value as keyof typeof loanPurposeTypesStatusCode];
  return '';
};

const mortgagePaymentTypesStatusCode = (t: TranslationType) => {
  return {
    '01': t('Status-Code-Mortgage-Payment-Type-Weekly'),
    '02': t('Status-Code-Mortgage-Payment-Type-Weekly-Accelerated'),
    '03': t('Status-Code-Mortgage-Payment-Type-Bi-Weekly'),
    '04': t('Status-Code-Mortgage-Payment-Type-Bi-Weekly-Accelerated'),
    '05': t('Status-Code-Mortgage-Payment-Type-Bi-Monthly'),
    '06': t('Status-Code-Mortgage-Payment-Type-Monthly')
  };
};

export const mortgagePaymentTypes = (value: string, t: TranslationType): string => {
  if (value in mortgagePaymentTypesStatusCode(t))
    return mortgagePaymentTypesStatusCode(t)[value as keyof typeof mortgagePaymentTypesStatusCode];
  return '';
};

const residentialStatusTypesStatusCode = (t: TranslationType) => {
  return {
    '01': t('Status-Code-Residential_status-Type-Own'),
    '02': t('Status-Code-Residential_status-Type-Rent'),
    '03': t('Status-Code-Residential_status-Type-Live-With-Family'),
    '99': t('Status-Code-Residential_status-Type-Other')
  };
};

export const residentialStatusTypes = (value: string, t: TranslationType): string => {
  if (value in residentialStatusTypesStatusCode(t))
    return residentialStatusTypesStatusCode(t)[
      value as keyof typeof residentialStatusTypesStatusCode
    ];
  return '';
};

const propertyListingTypesStatusCode = (t: TranslationType) => {
  return {
    '01': t('Status-Code-Property-Listing-Type-MLS'),
    '02': t('Status-Code-Property-Listing-Type-Private-Sale'),
    '03': t('Status-Code-Property-Listing-Type-Builder/Contractor'),
    '99': t('Status-Code-Property-Listing-Type-Other')
  };
};

export const propertyListingTypes = (value: string, t: TranslationType): string => {
  if (value in propertyListingTypesStatusCode(t))
    return propertyListingTypesStatusCode(t)[value as keyof typeof propertyListingTypesStatusCode];
  return '';
};

const sourceOfBusinessTypesStatusCode = (t: TranslationType) => {
  return {
    '01': t('Status-Code-Source-Of-Business-Type-Existing Client'),
    '02': t('Status-Code-Source-Of-Business-Type-Walk-In-Meet-Client'),
    '03': t('Status-Code-Source-Of-Business-Type-Realtor'),
    '04': t('Status-Code-Source-Of-Business-Type-Broker'),
    '05': t('Status-Code-Source-Of-Business-Type-Lawyer'),
    '06': t('Status-Code-Source-Of-Business-Type-Ported-Loan'),
    '07': t('"Status-Code-Source-Of-Business-Type-Construction-Contract-Builder'),
    '08': t('Status-Code-Source-Of-Business-Type-Self-Directed-Rrsp/Rrif'),
    '09': t('Status-Code-Source-Of-Business-Type-Builder-Pre-Sold'),
    '10': t('Status-Code-Source-Of-Business-Type-Builder-Pre-Sold-Subdiv-Disc.'),
    '11': t('Status-Code-Source-Of-Business-Type-Owner-Builder'),
    '12': t('Status-Code-Source-Of-Business-Type-Construction-Financing'),
    '13': t('Status-Code-Source-Of-Business-Type-Mortgage-Specialist'),
    '14': t('Status-Code-Source-Of-Business-Type-Branch'),
    '15': t('Status-Code-Source-Of-Business-Type-On-Line'),
    '16': t('Status-Code-Source-Of-Business-Type-Call-Centre'),
    '31': t('Status-Code-Source-Of-Business-Type-Approved-Correspondent'),
    '32': t('Status-Code-Source-Of-Business-Type-Approved-Lender'),
    '98': t('Status-Code-Source-Of-Business-Type-Lender-Staff'),
    '99': t('Status-Code-Source-Of-Business-Type-Other')
  };
};

export const sourceOfBusinessTypes = (value: string, t: TranslationType): string => {
  if (value in sourceOfBusinessTypesStatusCode(t))
    return sourceOfBusinessTypesStatusCode(t)[
      value as keyof typeof sourceOfBusinessTypesStatusCode
    ];
  return '';
};

const mortgageSecurityPriorityRankingStatusCode = (t: TranslationType) => {
  return {
    '1': t('Status-Code-Mortage-Security-Priority-Type-First-Priority'),
    '2': t('Status-Code-Mortage-Security-Priority-Type-Second-Priority'),
    '4': t('Status-Code-Mortage-Security-Priority-Type-Ministerial-Guarantee'),
    '7': t('Status-Code-Mortage-Security-Priority-Type-Chattel')
  };
};

export const mortgageSecurityPriorityRankingTypes = (value: string, t: TranslationType): string => {
  if (value in mortgageSecurityPriorityRankingStatusCode(t))
    return mortgageSecurityPriorityRankingStatusCode(t)[
      value as keyof typeof mortgageSecurityPriorityRankingStatusCode
    ];
  return '';
};

const mortgageSecurityStatusCode = (t: TranslationType) => {
  return {
    '01': t('Status-Code-Mortage-Security-Type-Second-Standing'),
    '02': t('Status-Code-Mortage-Security-Type-Ministerial-Amortizing'),
    '03': t('Status-Code-Mortage-Security-Type-Non-Amortizing')
  };
};

export const mortgageSecurityTypes = (value: string, t: TranslationType): string => {
  if (value in mortgageSecurityStatusCode(t))
    return mortgageSecurityStatusCode(t)[value as keyof typeof mortgageSecurityStatusCode];
  return '';
};

const propertyValuationMethodStatusCode = (t: TranslationType) => {
  return {
    '01': t('Status-Code-Property-Valuation-Method-Full-Appraisal'),
    '02': t('Status-Code-Property-Valuation-Method-Drive-By-appraisal'),
    '03': t('Status-Code-Property-Valuation-Method-Desk-Top-Appraisal'),
    '04': t('Status-Code-Property-Valuation-Method-AVM'),
    '05': t('Status-Code-Property-Valuation-Method-Emili'),
    '06': t('Status-Code-Property-Valuation-Method-MLS'),
    '07': t('Status-Code-Property-Valuation-Method-Municipal-Tax-Assessment'),
    '08': t('Status-Code-Property-Valuation-Underwriter-Comparison-Sales-Review'),
    '09': t('Status-Code-Property-Valuation-Method-Borrower-Stated-Value'),
    '99': t('Status-Code-Property-Valuation-Method-Other')
  };
};

export const propertyValuationMethodTypes = (value: string, t: TranslationType): string => {
  if (value in propertyValuationMethodStatusCode(t))
    return propertyValuationMethodStatusCode(t)[
      value as keyof typeof propertyValuationMethodStatusCode
    ];
  return '';
};

const lowRatioCharacteristicsResult = (t: TranslationType) => {
  return {
    '1': t('CMHC-Low-Ratio-Characteristics-Result-Insurable'),
    '0': t('CMHC-Low-Ratio-Characteristics-Result-Non-Insurable')
  };
};

export const lowRatioCharacteristicsResultTypes = (value: string, t: TranslationType): string => {
  if (value in lowRatioCharacteristicsResult(t))
    return lowRatioCharacteristicsResult(t)[value as keyof typeof lowRatioCharacteristicsResult];
  return '';
};

const lowRatioCharacteristicsAge = (t: TranslationType) => {
  return {
    '01': t('CMHC-Low-Ratio-Characteristics-Result-Age-Less-Than-6'),
    '02': t('CMHC-Low-Ratio-Characteristics-Result-Age-6-To-12'),
    '03': t('CMHC-Low-Ratio-Characteristics-Result-Age-Greater-Than-12')
  };
};

export const lowRatioCharacteristicsAgeTypes = (value: string, t: TranslationType): string => {
  if (value in lowRatioCharacteristicsAge(t))
    return lowRatioCharacteristicsAge(t)[value as keyof typeof lowRatioCharacteristicsAge];
  return '';
};

const lowRatioCharacteristicsApplicationRisk = (t: TranslationType) => {
  return {
    '01': t('CMHC-Low-Ratio-Characteristics-Application-Risk-High'),
    '02': t('CMHC-Low-Ratio-Characteristics-Application-Risk-Medium'),
    '03': t('CMHC-Low-Ratio-Characteristics-Application-Risk-Low'),
    '04': t('CMHC-Low-Ratio-Characteristics-Application-Risk-Very-High')
  };
};

export const lowRatioCharacteristicsApplicationRiskTypes = (
  value: string,
  t: TranslationType
): string => {
  if (value in lowRatioCharacteristicsApplicationRisk(t))
    return lowRatioCharacteristicsApplicationRisk(t)[
      value as keyof typeof lowRatioCharacteristicsApplicationRisk
    ];
  return '';
};
